export default "__VITE_ASSET__BwgvPwcM__"